export const NotifierTypeList = [
  { name: '企业微信', value: 'wework', placeholder: '企业微信群机器人Wehbook URL' },
  { name: '飞书', value: 'feishu', placeholder: '飞书群机器人Wehbook URL' },
  { name: '邮箱', value: 'email', placeholder: '请输入电子邮箱' },
  { name: 'Server酱', value: 'serverchan', placeholder: 'Server酱SendKey或请求URL' },
]
